<template>
  <v-card class="pa-0 pb-10" tile>
    <Loader v-if="loading"/>
    <template v-else-if="contractor">
      <v-card-title>
        <h4 class="primary--text">
          {{ contractor.companyName }}
        </h4>
      </v-card-title>
      <v-card-subtitle>
        <span>{{ $t('tslContractors.vatNumber') }}: {{ contractor.vatNumber }}</span>
      </v-card-subtitle>
      <div class="background px-6">
        <v-tabs v-model="activeTab" :height="60" background-color="background" show-arrows center-active>
          <v-tab :ripple="false">{{ $t('tslContractors.tabs.information') }}</v-tab>
          <v-tab :ripple="false">{{ $t('tslContractors.tabs.documents') }}</v-tab>
          <v-tab :ripple="false">{{ $t('tslContractors.tabs.notes') }}</v-tab>
          <v-tab :ripple="false">{{ $t('tslContractors.tabs.history') }}</v-tab>
          <v-tab :ripple="false">{{ $t('tslContractors.tabs.ratings') }}</v-tab>
        </v-tabs>
      </div>
      <v-tabs-items v-model="activeTab" class="py-4">
        <v-tab-item>
          <Information v-if="contractor" :contractor-id="contractorId" @updated="loadContractor" />
        </v-tab-item>
        <v-tab-item>
          <Documents v-if="contractor" :contractor-id="contractorId" :contractor-type="contractor.type" />
        </v-tab-item>
        <v-tab-item>
          <Notes v-if="contractor" :contractor-id="contractorId" />
        </v-tab-item>
        <v-tab-item>
          <History v-if="contractor" :contractor-id="contractorId" />
        </v-tab-item>
        <v-tab-item>
          <Ratings v-if="contractor" :contractor-id="contractorId" />
        </v-tab-item>
      </v-tabs-items>
    </template>
  </v-card>
</template>

<script>
import Service from '@/services'
import Loader from '@/components/Loader'
import Information from './tabs/Information.vue'
import Documents from './tabs/Documents.vue'
import Notes from './tabs/Notes.vue'
import History from './tabs/History.vue'
import Ratings from './tabs/Ratings.vue'

export default {
  name: 'TSLContractorDetails',
  components: {
    Loader,
    Information,
    Documents,
    Notes,
    History,
    Ratings
  },
  data () {
    return {
      loading: true,
      activeTab: 0,
      contractor: null,
      contractorId: this.$route.params.id
    }
  },
  created () {
    this.loadContractor()
  },
  methods: {
    async loadContractor () {
      if (!this.contractorId) {
        this.$router.push({ name: 'TSLContractors' })
        return
      }
      this.loading = true
      try {
        const { data } = await Service.get('/TSLContractor/GetContractorDetails', { id: this.contractorId })
        this.contractor = data
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error loading contractor')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
